// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__K2GqJ","opacity-transition":"success_opacity-transition__l6bs+"};